import React, { useState } from 'react';
import MainLayout from '../../components/ui/MainLayout';
import Icon from '../../components/AppIcon';

// ─── Building / Location Data ────────────────────────────────────────────────
const BUILDINGS = [
  // Residences (top row)
  {
    id: 'g1', code: 'G1', name: 'Male Residence G1', category: 'residence',
    icon: 'Building2', color: '#E8A44A', textColor: '#fff',
    description: 'Male student residence building with standard rooms.',
    contact: '+20 3 459 0000', hours: '24/7',
    details: ['Male students only', 'Standard rooms', 'Common areas', 'Laundry room'],
    svgX: 155, svgY: 155, svgW: 110, svgH: 100,
  },
  {
    id: 'f1', code: 'F1', name: 'Female Residence F1', category: 'residence',
    icon: 'Building2', color: '#E8A44A', textColor: '#fff',
    description: 'Female student residence building.',
    contact: '+20 3 459 0001', hours: '24/7',
    details: ['Female students only', 'Standard rooms', 'Study lounge', 'Kitchenette'],
    svgX: 310, svgY: 115, svgW: 100, svgH: 95,
  },
  {
    id: 'f2', code: 'F2', name: 'Female Residence F2', category: 'residence',
    icon: 'Building2', color: '#E8A44A', textColor: '#fff',
    description: 'Female student residence building.',
    contact: '+20 3 459 0002', hours: '24/7',
    details: ['Female students only', 'Standard rooms', 'Study lounge', 'Kitchenette'],
    svgX: 450, svgY: 105, svgW: 105, svgH: 100,
  },
  {
    id: 'g2', code: 'G2', name: 'Male Residence G2', category: 'residence',
    icon: 'Building2', color: '#E8A44A', textColor: '#fff',
    description: 'Male student residence building.',
    contact: '+20 3 459 0003', hours: '24/7',
    details: ['Male students only', 'Standard rooms', 'Common areas', 'Laundry room'],
    svgX: 600, svgY: 130, svgW: 105, svgH: 100,
  },
  // Hotel Residence H
  {
    id: 'h', code: 'H', name: 'Hôtel Résidence', category: 'residence',
    icon: 'Hotel', color: '#E8A44A', textColor: '#fff',
    description: 'Hotel-style residence for visiting faculty and guests.',
    contact: '+20 3 459 0004', hours: '24/7',
    details: ['Hotel-style rooms', 'Premium amenities', 'Reception desk', 'Room service'],
    svgX: 115, svgY: 295, svgW: 105, svgH: 90,
  },
  // Permanent Staff Housing L
  {
    id: 'l', code: 'L', name: 'Permanent Staff Housing', category: 'residence',
    icon: 'Home', color: '#E8A44A', textColor: '#fff',
    description: 'Permanent housing for university staff and faculty.',
    contact: '+20 3 459 0005', hours: '24/7',
    details: ['Staff apartments', 'Full kitchen', 'Living area', 'Private bathroom'],
    svgX: 115, svgY: 415, svgW: 105, svgH: 90,
  },
  // Restaurant R
  {
    id: 'r', code: 'R', name: 'University Restaurant', category: 'dining',
    icon: 'UtensilsCrossed', color: '#E05C1A', textColor: '#fff',
    description: 'Main dining facility serving breakfast, lunch, and dinner.',
    contact: '+20 3 459 0010', hours: 'Breakfast 7–9AM · Lunch 12–2PM · Dinner 7–9PM',
    details: ['Capacity: 300 seats', 'Meal card accepted', 'Vegetarian options', 'Special diet available'],
    svgX: 335, svgY: 245, svgW: 120, svgH: 115,
  },
  // Conference Hall C
  {
    id: 'c', code: 'C', name: 'Conference Hall', category: 'conference',
    icon: 'Presentation', color: '#C2410C', textColor: '#fff',
    description: 'Main conference and lecture hall for academic events.',
    contact: '+20 3 459 0011', hours: 'Mon–Sat 7AM–10PM',
    details: ['Auditorium 500 seats', 'Seminar rooms', 'AV equipment', 'Booking required'],
    svgX: 335, svgY: 390, svgW: 120, svgH: 115,
  },
  // Library B
  {
    id: 'b', code: 'B', name: 'Library, CIFIP & Media Center', category: 'library',
    icon: 'BookOpen', color: '#7B3FA0', textColor: '#fff',
    description: 'University library, CIFIP, Communication and Audiovisual center.',
    contact: '+20 3 459 0012', hours: 'Mon–Sat 8AM–9PM',
    details: ['Main library', 'CIFIP center', 'Media lab', 'Study rooms'],
    svgX: 490, svgY: 340, svgW: 115, svgH: 110,
  },
  // Administration A
  {
    id: 'a', code: 'A', name: 'Administration', category: 'administration',
    icon: 'Landmark', color: '#64748B', textColor: '#fff',
    description: 'Main administrative offices for university management.',
    contact: '+20 3 459 0020', hours: 'Mon–Fri 8AM–5PM',
    details: ['Rector office', 'Finance dept.', 'Student services', 'Document processing'],
    svgX: 490, svgY: 480, svgW: 115, svgH: 95,
  },
  // Academic D1
  {
    id: 'd1', code: 'D1', name: 'Culture & Environment Dept.', category: 'academic',
    icon: 'GraduationCap', color: '#2B3A8C', textColor: '#fff',
    description: 'Department of Culture and Environment — academic building.',
    contact: '+20 3 459 0030', hours: 'Mon–Sat 7AM–9PM',
    details: ['Lecture halls', 'Faculty offices', 'Research labs', 'Student lounge'],
    svgX: 640, svgY: 400, svgW: 115, svgH: 110,
  },
  // Academic D2
  {
    id: 'd2', code: 'D2', name: 'Management & Health Dept.', category: 'academic',
    icon: 'GraduationCap', color: '#2B3A8C', textColor: '#fff',
    description: 'Department of Management and Health — academic building.',
    contact: '+20 3 459 0031', hours: 'Mon–Sat 7AM–9PM',
    details: ['Lecture halls', 'Faculty offices', 'Computer labs', 'Library access'],
    svgX: 640, svgY: 270, svgW: 115, svgH: 110,
  },
  // Sports & Wellness S (includes clinic services)
  {
    id: 's', code: 'S', name: 'Sports & Wellness Center', category: 'sports',
    icon: 'Dumbbell', color: '#1A7A4A', textColor: '#fff',
    description: 'Sports hall with gym, squash courts, leisure facilities, and on-site clinic services.',
    contact: '+20 3 459 0040', hours: 'Daily 6AM–10PM · Clinic Mon–Fri 8AM–6PM',
    details: ['Gym & fitness', 'Squash courts', 'Changing rooms', 'Clinic & first aid', 'Emergency referrals', 'Pharmacy'],
    svgX: 100, svgY: 530, svgW: 120, svgH: 100,
  },
  // Pool P
  {
    id: 'p', code: 'P', name: 'Swimming Pool', category: 'sports',
    icon: 'Waves', color: '#1A7A4A', textColor: '#fff',
    description: 'Olympic-size swimming pool open to all residents.',
    contact: '+20 3 459 0041', hours: 'Daily 7AM–8PM',
    details: ['Olympic pool', 'Changing rooms', 'Lifeguard on duty', 'Swimming lessons'],
    svgX: 240, svgY: 530, svgW: 110, svgH: 100,
  },
  // Resident Services RS
  {
    id: 'rs', code: 'RS', name: 'Resident Services', category: 'services',
    icon: 'ConciergeBell', color: '#0E7490', textColor: '#fff',
    description: 'Central hub for resident support, maintenance requests, and administrative services.',
    contact: '+20 3 459 0060', hours: 'Mon–Fri 8AM–6PM',
    details: ['Maintenance requests', 'Lost & Found', 'Room change requests', 'Visitor authorization'],
    svgX: 490, svgY: 600, svgW: 115, svgH: 80,
  },
];

const CATEGORIES = [
  { value: 'all', label: 'All Facilities', icon: 'LayoutGrid', color: '#6B7280' },
  { value: 'residence', label: 'Residences', icon: 'Building2', color: '#E8A44A' },
  { value: 'academic', label: 'Academic', icon: 'GraduationCap', color: '#2B3A8C' },
  { value: 'administration', label: 'Administration', icon: 'Landmark', color: '#64748B' },
  { value: 'library', label: 'Library & Media', icon: 'BookOpen', color: '#7B3FA0' },
  { value: 'conference', label: 'Conference Hall', icon: 'Presentation', color: '#C2410C' },
  { value: 'dining', label: 'Restaurant', icon: 'UtensilsCrossed', color: '#E05C1A' },
  { value: 'sports', label: 'Sports & Wellness', icon: 'Dumbbell', color: '#1A7A4A' },
  { value: 'services', label: 'Resident Services', icon: 'ConciergeBell', color: '#0E7490' },
];

const LEGEND_ITEMS = [
  { color: '#E8A44A', label: 'Residences (G1, G2, F1, F2, H, L)' },
  { color: '#E05C1A', label: 'Restaurant (R)' },
  { color: '#C2410C', label: 'Conference Hall (C)' },
  { color: '#2B3A8C', label: 'Academic Buildings (D1, D2)' },
  { color: '#7B3FA0', label: 'Library, CIFIP & Media (B)' },
  { color: '#64748B', label: 'Administration (A)' },
  { color: '#1A7A4A', label: 'Sports & Wellness · Pool (S, P)' },
  { color: '#0E7490', label: 'Resident Services (RS)' },
];

// ─── SVG Campus Map ───────────────────────────────────────────────────────────
function CampusSVG({ buildings, selectedId, onSelect }) {
  return (
    <svg
      viewBox="0 0 820 780"
      className="w-full h-full"
      style={{ fontFamily: 'Inter, Manrope, sans-serif' }}
    >
      {/* Campus boundary */}
      <path
        d="M 60 60 Q 60 30 100 25 L 720 25 Q 760 25 760 60 L 760 700 Q 760 755 700 755 L 120 755 Q 60 755 60 700 Z"
        fill="#F0F4F8" stroke="#CBD5E1" strokeWidth="2.5"
      />
      {/* Green landscaping zones */}
      <rect x="80" y="40" width="640" height="55" rx="8" fill="#C8E6C9" opacity="0.7" />
      <rect x="75" y="95" width="55" height="580" rx="6" fill="#C8E6C9" opacity="0.6" />
      <rect x="690" y="95" width="55" height="580" rx="6" fill="#C8E6C9" opacity="0.6" />
      <rect x="80" y="690" width="640" height="50" rx="8" fill="#C8E6C9" opacity="0.7" />
      {/* Central green areas */}
      <ellipse cx="270" cy="350" rx="55" ry="45" fill="#A5D6A7" opacity="0.6" />
      <ellipse cx="580" cy="470" rx="40" ry="35" fill="#A5D6A7" opacity="0.5" />
      <rect x="240" y="460" width="80" height="60" rx="6" fill="#81C784" opacity="0.5" />
      {/* Football pitch */}
      <rect x="240" y="340" width="80" height="110" rx="4" fill="#4CAF50" opacity="0.85" stroke="#388E3C" strokeWidth="1.5" />
      <rect x="248" y="348" width="64" height="94" rx="2" fill="none" stroke="#fff" strokeWidth="1" opacity="0.8" />
      <circle cx="280" cy="395" r="10" fill="none" stroke="#fff" strokeWidth="1" opacity="0.8" />
      <line x1="280" y1="348" x2="280" y2="442" stroke="#fff" strokeWidth="1" opacity="0.8" />
      <text x="280" y="465" textAnchor="middle" fontSize="8" fill="#2E7D32" fontWeight="600">Football Pitch</text>
      {/* Main roads */}
      <rect x="80" y="225" width="640" height="18" rx="2" fill="#B0BEC5" opacity="0.9" />
      <rect x="300" y="80" width="18" height="620" rx="2" fill="#B0BEC5" opacity="0.9" />
      <rect x="80" y="510" width="640" height="14" rx="2" fill="#CFD8DC" opacity="0.8" />
      <rect x="625" y="80" width="14" height="620" rx="2" fill="#CFD8DC" opacity="0.8" />
      {/* Walkway paths */}
      <path d="M 318 243 Q 380 280 390 390" stroke="#E0E0E0" strokeWidth="6" fill="none" strokeLinecap="round" />
      <path d="M 318 243 Q 380 300 490 350" stroke="#E0E0E0" strokeWidth="6" fill="none" strokeLinecap="round" />
      <path d="M 455 505 Q 490 520 490 600" stroke="#E0E0E0" strokeWidth="5" fill="none" strokeLinecap="round" />
      {/* Parking areas */}
      <rect x="700" y="130" width="50" height="90" rx="4" fill="#ECEFF1" stroke="#90A4AE" strokeWidth="1.5" strokeDasharray="4,2" />
      <text x="725" y="178" textAnchor="middle" fontSize="7.5" fill="#607D8B" fontWeight="600">PARKING</text>
      {[140, 150, 160, 170, 180, 190, 200]?.map(y => (
        <line key={y} x1="703" y1={y} x2="748" y2={y} stroke="#90A4AE" strokeWidth="0.8" />
      ))}
      <rect x="700" y="240" width="50" height="70" rx="4" fill="#ECEFF1" stroke="#90A4AE" strokeWidth="1.5" strokeDasharray="4,2" />
      <text x="725" y="278" textAnchor="middle" fontSize="7.5" fill="#607D8B" fontWeight="600">PARKING</text>
      {/* Decorative trees */}
      {[
        [95, 105], [95, 140], [95, 175], [95, 210],
        [95, 430], [95, 470], [95, 510],
        [710, 105], [710, 140], [710, 175], [710, 210],
        [710, 430], [710, 470], [710, 510],
        [130, 720], [200, 720], [280, 720], [360, 720], [440, 720], [520, 720], [600, 720], [680, 720],
        [130, 55], [200, 55], [280, 55], [360, 55], [440, 55], [520, 55], [600, 55], [680, 55],
        [230, 310], [230, 360], [230, 410],
        [570, 310], [570, 360],
      ]?.map(([cx, cy], i) => (
        <g key={i}>
          <circle cx={cx} cy={cy} r="9" fill="#66BB6A" opacity="0.75" />
          <circle cx={cx} cy={cy} r="5" fill="#43A047" opacity="0.6" />
        </g>
      ))}
      {/* Roundabout / central circle */}
      <circle cx="390" cy="395" r="22" fill="none" stroke="#B0BEC5" strokeWidth="3" />
      <circle cx="390" cy="395" r="14" fill="#C8E6C9" stroke="#A5D6A7" strokeWidth="1.5" />
      {/* ── Buildings ── */}
      {buildings?.map(b => {
        const isSelected = selectedId === b?.id;
        return (
          <g key={b?.id} onClick={() => onSelect(b)} style={{ cursor: 'pointer' }}>
            {/* Shadow */}
            <rect
              x={b?.svgX + 4} y={b?.svgY + 4}
              width={b?.svgW} height={b?.svgH}
              rx="6" fill="rgba(0,0,0,0.12)"
            />
            {/* Building body */}
            <rect
              x={b?.svgX} y={b?.svgY}
              width={b?.svgW} height={b?.svgH}
              rx="6"
              fill={b?.color}
              stroke={isSelected ? '#1E40AF' : 'rgba(255,255,255,0.4)'}
              strokeWidth={isSelected ? 3 : 1.5}
              opacity={isSelected ? 1 : 0.92}
            />
            {/* Selection glow */}
            {isSelected && (
              <rect
                x={b?.svgX - 3} y={b?.svgY - 3}
                width={b?.svgW + 6} height={b?.svgH + 6}
                rx="9" fill="none"
                stroke="#3B82F6" strokeWidth="2" opacity="0.5"
              />
            )}
            {/* Building code label */}
            <text
              x={b?.svgX + b?.svgW / 2}
              y={b?.svgY + b?.svgH / 2 + 2}
              textAnchor="middle"
              dominantBaseline="middle"
              fontSize={b?.svgW > 100 ? '22' : '18'}
              fontWeight="800"
              fill={b?.textColor}
              opacity="0.95"
              style={{ userSelect: 'none', letterSpacing: '0.5px' }}
            >
              {b?.code}
            </text>
          </g>
        );
      })}
      {/* ── Accessibility icons (wheelchair) ── */}
      {[
        [320, 248], [320, 518], [480, 248], [480, 518], [630, 248],
      ]?.map(([x, y], i) => (
        <g key={i} transform={`translate(${x},${y})`}>
          <circle cx="0" cy="0" r="7" fill="#2196F3" opacity="0.85" />
          <text x="0" y="1" textAnchor="middle" dominantBaseline="middle" fontSize="8" fill="#fff">♿</text>
        </g>
      ))}
      {/* Campus title */}
      <text x="410" y="18" textAnchor="middle" fontSize="11" fontWeight="700" fill="#1E3A5F" letterSpacing="2">
        UNIVERSITÉ SENGHOR — CAMPUS MASTER PLAN
      </text>
      {/* Address footer */}
      <text x="760" y="740" textAnchor="end" fontSize="7.5" fill="#78909C">
        Quartier des Universités · Borg El-Arab El-Jadida · 5220220 Égypte
      </text>
    </svg>
  );
}

// ─── Main Component ───────────────────────────────────────────────────────────
export default function CampusMap() {
  const [selectedBuilding, setSelectedBuilding] = useState(null);
  const [filterCategory, setFilterCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [showLegend, setShowLegend] = useState(true);

  const filtered = BUILDINGS?.filter(b => {
    const matchCat = filterCategory === 'all' || b?.category === filterCategory;
    const matchSearch =
      !searchQuery ||
      b?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      b?.code?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      b?.description?.toLowerCase()?.includes(searchQuery?.toLowerCase());
    return matchCat && matchSearch;
  });

  const filteredIds = new Set(filtered.map(b => b.id));
  const mapBuildings = BUILDINGS?.map(b => ({
    ...b,
    color: filteredIds?.has(b?.id) ? b?.color : '#D1D5DB',
    textColor: filteredIds?.has(b?.id) ? b?.textColor : '#9CA3AF',
  }));

  const handleSelect = (b) => {
    setSelectedBuilding(prev => prev?.id === b?.id ? null : b);
  };

  return (
    <MainLayout>
      <div className="space-y-5">
        {/* Header */}
        <div className="flex items-start justify-between flex-wrap gap-3">
          <div>
            <h1 className="text-2xl font-bold text-foreground" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Interactive Campus Map
            </h1>
            <p className="text-sm text-muted-foreground mt-1">
              Université Senghor — Borg El-Arab El-Jadida, Egypt
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setShowLegend(v => !v)}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-border bg-card text-xs font-medium text-muted-foreground hover:bg-muted transition-colors"
            >
              <Icon name="List" size={13} />
              {showLegend ? 'Hide Legend' : 'Show Legend'}
            </button>
          </div>
        </div>

        {/* Search & Category Filters */}
        <div className="flex flex-wrap gap-2 items-center">
          <div className="relative">
            <Icon name="Search" size={13} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <input
              type="text"
              value={searchQuery}
              onChange={e => setSearchQuery(e?.target?.value)}
              placeholder="Search buildings..."
              className="pl-8 pr-3 py-2 rounded-lg border border-border bg-background text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary/30 w-48"
            />
          </div>
          <div className="flex flex-wrap gap-1.5">
            {CATEGORIES?.map(cat => (
              <button
                key={cat?.value}
                onClick={() => setFilterCategory(cat?.value)}
                className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium transition-all border ${
                  filterCategory === cat?.value
                    ? 'text-white border-transparent shadow-sm'
                    : 'bg-card border-border text-muted-foreground hover:bg-muted'
                }`}
                style={filterCategory === cat?.value ? { backgroundColor: cat?.color, borderColor: cat?.color } : {}}
              >
                <Icon name={cat?.icon} size={11} />
                {cat?.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-4 gap-5">
          {/* ── SVG Map ── */}
          <div className="xl:col-span-3 bg-white dark:bg-card border border-border rounded-2xl overflow-hidden shadow-sm">
            <div className="px-4 py-3 border-b border-border flex items-center justify-between">
              <div>
                <h2 className="text-sm font-semibold text-foreground">Campus Overview</h2>
                <p className="text-xs text-muted-foreground mt-0.5">Click any building to view details</p>
              </div>
              <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
                <Icon name="ZoomIn" size={12} />
                <span>Scroll to zoom</span>
              </div>
            </div>

            <div className="relative bg-gradient-to-br from-slate-50 to-blue-50 dark:from-slate-900 dark:to-slate-800" style={{ height: '520px' }}>
              <div className="w-full h-full overflow-auto">
                <div style={{ minWidth: '700px', height: '100%', padding: '8px' }}>
                  <CampusSVG
                    buildings={mapBuildings}
                    selectedId={selectedBuilding?.id}
                    onSelect={handleSelect}
                  />
                </div>
              </div>

              {/* Legend overlay */}
              {showLegend && (
                <div className="absolute bottom-3 left-3 bg-white/95 dark:bg-black/80 rounded-xl border border-border shadow-lg p-3 text-xs space-y-1.5 max-w-[220px]">
                  <div className="font-semibold text-foreground mb-2 flex items-center gap-1.5">
                    <Icon name="MapPin" size={11} />
                    Legend
                  </div>
                  {LEGEND_ITEMS?.map(l => (
                    <div key={l?.label} className="flex items-start gap-2">
                      <div
                        className="w-3 h-3 rounded-sm flex-shrink-0 mt-0.5"
                        style={{ backgroundColor: l?.color }}
                      />
                      <span className="text-foreground leading-tight">{l?.label}</span>
                    </div>
                  ))}
                  <div className="pt-1 border-t border-border mt-1 space-y-1">
                    <div className="flex items-center gap-2">
                      <div className="w-3 h-2 rounded-sm bg-[#B0BEC5]" />
                      <span className="text-muted-foreground">Roads</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="w-3 h-2 rounded-sm bg-[#C8E6C9]" />
                      <span className="text-muted-foreground">Green Areas</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="w-3 h-2 rounded-sm bg-[#ECEFF1] border border-[#90A4AE]" />
                      <span className="text-muted-foreground">Parking</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="text-[10px]">♿</span>
                      <span className="text-muted-foreground">Accessible Route</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* ── Side Panel ── */}
          <div className="xl:col-span-1 space-y-3">
            {selectedBuilding ? (
              <div className="bg-card border border-border rounded-2xl overflow-hidden shadow-sm">
                {/* Color header */}
                <div
                  className="px-4 py-4 flex items-start justify-between"
                  style={{ backgroundColor: selectedBuilding?.color }}
                >
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
                      <Icon name={selectedBuilding?.icon} size={20} className="text-white" />
                    </div>
                    <div>
                      <div className="text-white/80 text-xs font-medium uppercase tracking-wide">
                        {CATEGORIES?.find(c => c?.value === selectedBuilding?.category)?.label}
                      </div>
                      <div className="text-white font-bold text-base leading-tight">
                        {selectedBuilding?.code}
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => setSelectedBuilding(null)}
                    className="p-1 rounded-lg bg-white/20 hover:bg-white/30 transition-colors"
                  >
                    <Icon name="X" size={14} className="text-white" />
                  </button>
                </div>
                <div className="p-4 space-y-4">
                  <div>
                    <h3 className="font-bold text-foreground text-sm">{selectedBuilding?.name}</h3>
                    <p className="text-xs text-muted-foreground mt-1 leading-relaxed">{selectedBuilding?.description}</p>
                  </div>

                  <div className="space-y-2.5">
                    <div className="flex items-start gap-2.5">
                      <div className="w-6 h-6 rounded-md bg-muted flex items-center justify-center flex-shrink-0">
                        <Icon name="Clock" size={12} className="text-muted-foreground" />
                      </div>
                      <div>
                        <div className="text-[10px] text-muted-foreground uppercase tracking-wide">Hours</div>
                        <div className="text-xs text-foreground font-medium">{selectedBuilding?.hours}</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-2.5">
                      <div className="w-6 h-6 rounded-md bg-muted flex items-center justify-center flex-shrink-0">
                        <Icon name="Phone" size={12} className="text-muted-foreground" />
                      </div>
                      <div>
                        <div className="text-[10px] text-muted-foreground uppercase tracking-wide">Contact</div>
                        <a
                          href={`tel:${selectedBuilding?.contact}`}
                          className="text-xs text-primary hover:underline font-medium"
                        >
                          {selectedBuilding?.contact}
                        </a>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="text-[10px] text-muted-foreground uppercase tracking-wide mb-2">Facilities</div>
                    <div className="space-y-1.5">
                      {selectedBuilding?.details?.map((d, i) => (
                        <div key={i} className="flex items-center gap-2 text-xs text-foreground">
                          <div
                            className="w-1.5 h-1.5 rounded-full flex-shrink-0"
                            style={{ backgroundColor: selectedBuilding?.color }}
                          />
                          {d}
                        </div>
                      ))}
                    </div>
                  </div>

                  <a
                    href={`tel:${selectedBuilding?.contact}`}
                    className="flex items-center justify-center gap-2 w-full py-2 rounded-lg text-white text-xs font-semibold transition-opacity hover:opacity-90"
                    style={{ backgroundColor: selectedBuilding?.color }}
                  >
                    <Icon name="Phone" size={13} />
                    Call Now
                  </a>
                </div>
              </div>
            ) : (
              <div className="bg-card border border-border rounded-2xl overflow-hidden shadow-sm">
                <div className="px-4 py-3 border-b border-border">
                  <h2 className="text-sm font-semibold text-foreground">
                    {filtered?.length} {filtered?.length === 1 ? 'Facility' : 'Facilities'}
                  </h2>
                </div>
                <div className="divide-y divide-border max-h-[460px] overflow-y-auto">
                  {filtered?.length === 0 ? (
                    <div className="py-10 text-center text-muted-foreground">
                      <Icon name="MapPin" size={28} className="mx-auto mb-2 opacity-30" />
                      <p className="text-sm">No facilities found</p>
                    </div>
                  ) : (
                    filtered?.map(b => (
                      <button
                        key={b?.id}
                        onClick={() => handleSelect(b)}
                        className="w-full flex items-center gap-3 px-4 py-3 hover:bg-muted/50 transition-colors text-left"
                      >
                        <div
                          className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
                          style={{ backgroundColor: b?.color }}
                        >
                          <Icon name={b?.icon} size={14} className="text-white" />
                        </div>
                        <div className="min-w-0 flex-1">
                          <div className="text-xs font-semibold text-foreground truncate">{b?.name}</div>
                          <div className="text-[10px] text-muted-foreground truncate">{b?.hours}</div>
                        </div>
                        <div
                          className="text-[10px] font-bold px-1.5 py-0.5 rounded text-white flex-shrink-0"
                          style={{ backgroundColor: b?.color }}
                        >
                          {b?.code}
                        </div>
                      </button>
                    ))
                  )}
                </div>
              </div>
            )}

            {/* Quick Reference Card */}
            <div className="bg-card border border-border rounded-2xl p-4 shadow-sm">
              <h3 className="text-xs font-semibold text-foreground mb-3 flex items-center gap-1.5">
                <Icon name="Info" size={12} />
                Building Key
              </h3>
              <div className="grid grid-cols-2 gap-x-3 gap-y-1.5">
                {[
                  ['A', 'Administration'],
                  ['B', 'Library & CIFIP'],
                  ['C', 'Conference Hall'],
                  ['D1', 'Academic (Culture)'],
                  ['D2', 'Academic (Mgmt)'],
                  ['F1/F2', 'Female Residences'],
                  ['G1/G2', 'Male Residences'],
                  ['H', 'Hôtel Résidence'],
                  ['L', 'Staff Housing'],
                  ['P', 'Swimming Pool'],
                  ['R', 'Restaurant'],
                  ['RS', 'Resident Services'],
                  ['S', 'Sports & Wellness'],
                ]?.map(([code, label]) => (
                  <div key={code} className="flex items-center gap-1.5">
                    <span className="text-[10px] font-bold text-primary w-8 flex-shrink-0">{code}</span>
                    <span className="text-[10px] text-muted-foreground truncate">{label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
